import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  if(process.env.NODE_ENV === 'dev'){
    return Cookies.get(TokenKey)
  }else{
    return Cookies.get(TokenKey, { domain: '.gsisc.cn' })
  }
}
export function getUserInfo(){
  if(process.env.NODE_ENV === 'dev'){
    return Cookies.get('userInfo')
  }else{
    return Cookies.get('userInfo', { domain: '.gsisc.cn' })
  }
}

export function setToken(token) {
  if(process.env.NODE_ENV === 'dev'){
    return Cookies.set(TokenKey, token,{ expires: 1})
  }else{
    return Cookies.set(TokenKey, token,{ expires: 1, domain: '.gsisc.cn'})
  }
}
export function setUserInfo(userinfo){
  if(process.env.NODE_ENV === 'dev'){
    return Cookies.set('userInfo', userinfo,{ expires:1})
  }else{
	  return Cookies.set('userInfo', userinfo,{ expires:1, domain: '.gsisc.cn'})
  }
}

export function removeUserInfo(){
  if(process.env.NODE_ENV === 'dev'){
    return Cookies.remove('userInfo')
  }else{
	  return Cookies.remove('userInfo',{ domain: '.gsisc.cn'})
  }
}

export function removeToken() {
  if(process.env.NODE_ENV === 'dev'){
    return Cookies.remove(TokenKey)
  }else{
	  return Cookies.remove(TokenKey,{ domain: '.gsisc.cn'})
  }
}
